import { EmployeeState } from 'src/types/redux';
import {
  FETCH_EMPLOYEE_FAILURE,
  FETCH_EMPLOYEE_REQUEST,
  FETCH_EMPLOYEE_SUCCESS,
  EmployeeActionType,
} from '../types/employeeTypes';

const initialState: EmployeeState = {
  error: '',
  loading: false,
  employeeData: [],
};

export const employeeReducer = (
  state = initialState,
  action: EmployeeActionType
): EmployeeState => {
  switch (action?.type) {
    case FETCH_EMPLOYEE_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case FETCH_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        employeeData: action?.payload,
      };
    case FETCH_EMPLOYEE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action?.payload,
      };
    default:
      return state;
  }
};
